import { render, staticRenderFns } from "./TrademarkOwnerList.vue?vue&type=template&id=7c4be178&"
import script from "./TrademarkOwnerList.vue?vue&type=script&lang=js&"
export * from "./TrademarkOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOwnerList.vue?vue&type=style&index=0&id=7c4be178&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports